// Resources, /cashflow/resources: the shared Resources (sections Adam names, the 5 kinds, release
// rules, yours for life; decision 8) in the course's look, then PCFL v3's Bonuses card for Pick your
// patch where the course has episodes. PCFL v3 drew its downloads by module with a separate Tools
// list; in the hub they're the admin's sections, and the stacker tool comes when it's built and placed.
import { Link } from '../../lib/router.jsx'
import { useProductData } from '../../product/ProductData.jsx'
import { ResourcesSection } from '../../product/Resources.jsx'
import { menuLabel } from '../../product/model.js'
import { COPY } from '../../products/ondemand/copy.js'
import { episodesOf } from '../../products/ondemand/model.js'
import '../../styles/ondemand.css'

export default function OnDemandResources({ product }) {
  const { data } = useProductData()
  const episodes = episodesOf(data)
  return (
    <div className="od od-res">
      <ResourcesSection product={product} headingLevel="h1"
        empty={(
          <header className="od-head">
            <h1 className="od-h1">{menuLabel('resources')}</h1>
            <p className="od-lede">{COPY.emptyResources(product.name)}</p>
          </header>
        )} />
      {episodes.length > 0 && (
        <section className="od-bonus" aria-labelledby="od-bonus-h">
          <h2 className="od-section-h" id="od-bonus-h">{COPY.bonuses}</h2>
          <div className="od-card od-tool">
            <div>
              <h3 className="od-tool-h">{COPY.patchTitle}</h3>
              <p className="od-tool-line">{COPY.patchCardLine}</p>
            </div>
            <Link className="od-btn od-btn--quiet" to={`${product.path}/episodes`}>{COPY.patchCardButton}</Link>
          </div>
        </section>
      )}
    </div>
  )
}
